
import { defineComponent, PropType } from 'vue';
import elementIds from '@/const/elementIds.json';
import IncrediInputNumWithMenu from '../inputs/incrediInputNumWithMenu.vue';
import actionMenuPortalContainer from './agents-menu/components/action-menu-portal-container.vue';
import { SelectedAgent } from './AgentActionMenu.types';

export default defineComponent({
  components: { actionMenuPortalContainer, IncrediInputNumWithMenu },
  props: {
    buildCacheSettings: {
      type: Object as PropType<SelectedAgent['buildCacheSettings']>,
      default: null,
    },
  },
  setup() {
    return { elementIds };
  },
  data() {
    return {
      cacheSizeGB: 0 as number | null | undefined,
    };
  },
  computed: {
    cacheSizeValid() {
      return this.cacheSizeGB && this.cacheSizeGB >= 1 && this.cacheSizeGB <= 10000;
    },
  },
  created() {
    if (this.buildCacheSettings) this.cacheSizeGB = this.buildCacheSettings.cacheSizeGB;
  },
  methods: {
    onSubmit() {
      (this.$refs['acfl--form'] as any).validate().then((success: boolean) => {
        if (success) {
          this.$emit('submit', { CacheSizeGB: this.cacheSizeGB });
        }
      });
    },
  },
});
